import React from "react";
import { Table } from "antd";
import Utils from "../../../../utility/Utils";

const DailyStatsReportTable = ({ tableData, loading }) => {
  const columns = [
    {
      title: "Serial Number",
      dataIndex: "serialnumber",
      key: "serialnumber",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 100,
    },
    {
      title: "GW Created",
      dataIndex: "gateway_created",
      key: "gateway_created",
      render: (text, record) => (text ? Utils.istTime(text) : "NA"),
      width: 100,
    },
    {
      title: "GW Model",
      dataIndex: "gateway_model",
      key: "gateway_model",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 100,
    },

    {
      title: "GW Name",
      dataIndex: "gateway_name",
      key: "gateway_name",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 100,
    },
    {
      title: "GW Owner",
      dataIndex: "username",
      key: "gateway_owner",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 100,
    },
    {
      title: "GW Current Status",
      dataIndex: "connectionstatus",
      key: "gateway_current_status",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 100,
    },
    {
      title: "GW Offline Time",
      dataIndex: "gateway_last_offline",
      key: "gateway_last_offline",
      render: (text, record) => (text ? Utils.istTime(text) : "NA"),
      width: 100,
    },
    {
      title: "GW Offline in Last 24 Hrs",
      dataIndex: "gateway_offline_count",
      key: "gateway_offline_count",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Smartcable Status",
      dataIndex: "smartcable_status",
      key: "smartcable_status",
      render: (text, record) => {
        return text ? text : "NA";
      },
      width: 100,
    },
    {
      title: "SC Offline Time If Offline For More Than 24 Hrs",
      dataIndex: "sc_last_offline",
      key: "sc_last_offline",
      render: (text, record) => (text ? Utils.istTime(text) : "NA"),
      width: 150,
    },
    {
      title: "SC Offline In Last 24 Hours",
      dataIndex: "sc_offline_count",
      key: "sc_offline_count",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Floor",
      dataIndex: "floors",
      key: "floors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Room",
      dataIndex: "rooms",
      key: "rooms",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Sensor",
      dataIndex: "sensors",
      key: "sensors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Zigbee EndDevice",
      dataIndex: "zigbee_sensors",
      key: "zigbee_sensors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Zigbee Router",
      dataIndex: "zigbee_routers",
      key: "zigbee_routers",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Offline Zigbee Router",
      dataIndex: "zigbee_routers_offline",
      key: "zigbee_routers_offline",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Wise Sensor",
      dataIndex: "wise_sensors",
      key: "wise_sensors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Local Wise Sensor",
      dataIndex: "local_wise_sensors",
      key: "local_wise_sensors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Remote Wise Sensor",
      dataIndex: "remote_wise_sensors",
      key: "remote_wise_sensors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Camera",
      dataIndex: "cameras",
      key: "cameras",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Sensor Offline",
      dataIndex: "sensors_offline",
      key: "sensors_offline",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Camera Offline",
      dataIndex: "cameras_offline",
      key: "cameras_offline",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Total Alarm",
      dataIndex: "alarms",
      key: "alarms",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
    {
      title: "Unstable Devices (offline more than 5 times a day)",
      dataIndex: "unstable_sensors",
      key: "unstable_sensors",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 150,
    },
    {
      title: "Total Secondary Users",
      dataIndex: "secondary_user",
      key: "secondary_user",
      render: (text, record) => {
        return text || text === 0 ? text : "NA";
      },
      width: 100,
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={tableData}
        className="report-table"
        size="small"
        pagination={{ defaultPageSize: 50 }}
        scroll={{ x: "max-content", y: "50vh" }}
        loading={loading}
      />
    </>
  );
};

export default DailyStatsReportTable;
